import React from "react";
import {controlPropTypes} from "../formhelpers";

export default class Label extends React.Component {
    render() {
        const {descriptor, enabled, controlOnly} = this.props;
        const selector = `control-container-${descriptor.key}`;
        if(descriptor.disableBehaviour === "hide" && !enabled) {
            // control is disabled and should be hidden.
            return null;
        }

        const Control = (
            <div
                id={descriptor.id}
                className={`${selector} react-control widget-label ${ controlOnly ? "form-group" : ""}`}
                data-control-type={descriptor.control}
                data-shortname={descriptor.key}
                data-widget-label={descriptor.label}
            >
                <span>{descriptor.label}</span>
            </div>
        );

        if(controlOnly) {
            return Control;
        }

        return (
            <div className="form-item">
                {Control}
            </div>
        );
    }
}

Label.propTypes = controlPropTypes(null, false);



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/Widget/label.js